export function loadExtraAddresses() {
  const container = document.getElementById("js-address-content");
  const button = document.getElementById("js-more-addresses");
  const ADDRESSES_PER_PAGE = 50;

  if (!(button && container)) {return;}

  let offset = parseInt(button.dataset.offset || "0");
  const TOTAL_ADDRESSES = parseInt(container.dataset.totalAddresses || "0");

  const shouldLoadMoreAddresses = () => {
    return offset * ADDRESSES_PER_PAGE <= TOTAL_ADDRESSES
  };

  button.addEventListener("click", async () => {
    const loader = button.querySelector(".hide-loader");

    button.querySelector(".show-more-text").classList.add("hidden");
    loader.classList.remove("hide-loader");

    const data1 = await fetch(`${button.dataset.url}?offset=${offset}`).then(
      (data) => data.json(),
    );

    container.innerHTML += data1.html;

    button.querySelector(".show-more-text").classList.remove("hidden");
    loader.classList.add("hide-loader");

    offset++;

    if (!shouldLoadMoreAddresses()) {
      button.classList.add("hidden");
    }
  });
}
